import { CheckIcon, CloseIcon, DreamIcon, SearchIcon } from 'shared/ui/Icon'
import cls from './Round.module.scss'
import { classNames } from 'shared/lib/classNames/classNames'

//применить classNames

export const RoundStatus = {
    ACCEPTED: 'accepted',
    WANTED: 'wanted',
    REJECTED: 'rejected',
    SEARCH: 'search',
}

export const Round = (props) => {
    const { status, pos, changeState, className, disabledRound, readonly } =
        props
    let Icon

    if (status === 'accepted') {
        Icon = CheckIcon
    } else if (status === 'wanted') {
        Icon = DreamIcon
    } else if (status === 'search') {
        Icon = SearchIcon
    } else if (status === 'rejected') {
        Icon = CloseIcon
    }

    const mods = {
        [cls[status]]: true,
        [cls.static]: pos,
        [cls.disabled]: disabledRound,
        [cls.readonly]: readonly,
    }

    return (
        <div
            onClick={changeState}
            //  className={`${cls.Round} ${status === 'wanted' ? cls.Wanted : ''} ${pos ? cls.Static : ''}`}
            className={classNames(cls.Round, mods, [className])}
        >
            <Icon className={cls.Icon} />
        </div>
    )
}
